// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"4faed52f","5954":"f3035338"}[chunkId] + ".chunk.css";
};